import { Socket } from "socket.io-client";
import EndpointsEnum from "../models/EndpointsEnum";
import RoomEnum from "../models/RoomEnum";
import IUserUI from "../models/IUserUI";
import ISupplierModel from "../models/ISupplierModel";
import IUserJoinRoomDTO from "../models/DTO/IUserJoinRoomDTO";

export function joinSupplierRoom(socket: Socket | null, userModel: IUserUI, supplierModel: ISupplierModel): void {
    if (!socket) return;

    const payload: IUserJoinRoomDTO = {
        userGuid: userModel.guid,
        userToken: userModel.token,
        supplierGuid: supplierModel.guid,
        roomOption: RoomEnum.SUPPLIER,
    };

    socket.emit(EndpointsEnum.UserJoinRoom, payload);
}
